var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kanban-main" },
    [
      _c("dv-full-screen-container", [
        _c("div", { ref: "kanban", staticClass: "full-bg" }, [
          _c(
            "div",
            { staticClass: "screen-header", staticStyle: { flex: "1" } },
            [
              _c(
                "div",
                { staticClass: "header-cls1" },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "right",
                        width: "250",
                        trigger: "click",
                      },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "teamForm",
                          attrs: {
                            "label-position": "left",
                            inline: "",
                            size: "mini",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "看板模式" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择",
                                    filterable: "",
                                  },
                                  on: { change: _vm.changeMould },
                                  model: {
                                    value: _vm.kanbanMode,
                                    callback: function ($$v) {
                                      _vm.kanbanMode = $$v
                                    },
                                    expression: "kanbanMode",
                                  },
                                },
                                _vm._l(
                                  ["打分模式", "颁奖模式"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: index },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "参赛组别" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择",
                                    filterable: "",
                                  },
                                  on: { change: _vm.changeType },
                                  model: {
                                    value: _vm.ctType,
                                    callback: function ($$v) {
                                      _vm.ctType = $$v
                                    },
                                    expression: "ctType",
                                  },
                                },
                                _vm._l(_vm.dict.ct_type, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.display,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "参赛子组" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择",
                                    filterable: "",
                                  },
                                  on: { change: _vm.changeSubtype },
                                  model: {
                                    value: _vm.ctSubtype,
                                    callback: function ($$v) {
                                      _vm.ctSubtype = $$v
                                    },
                                    expression: "ctSubtype",
                                  },
                                },
                                _vm._l(_vm.dict.ct_subtype, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.display,
                                      value: item.index,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.kanbanMode == 1
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "荣获奖项" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择",
                                        filterable: "",
                                      },
                                      on: { change: _vm.changeGrade },
                                      model: {
                                        value: _vm.ctGrade,
                                        callback: function ($$v) {
                                          _vm.ctGrade = $$v
                                        },
                                        expression: "ctGrade",
                                      },
                                    },
                                    _vm._l(_vm.dict.ct_grade, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.display,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "停滞时长(S)" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100px" },
                                attrs: { min: 1 },
                                on: { change: _vm.handleChange },
                                model: {
                                  value: _vm.timeStep,
                                  callback: function ($$v) {
                                    _vm.timeStep = $$v
                                  },
                                  expression: "timeStep",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "参赛阶段" } },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  on: { change: _vm.handleCheckedChange },
                                  model: {
                                    value: _vm.checkboxGroup,
                                    callback: function ($$v) {
                                      _vm.checkboxGroup = $$v
                                    },
                                    expression: "checkboxGroup",
                                  },
                                },
                                _vm._l(_vm.dict.ct_stage, function (item) {
                                  return _c(
                                    "el-checkbox-button",
                                    {
                                      key: item.value,
                                      attrs: { label: item.value },
                                    },
                                    [_vm._v(_vm._s(item.display))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-button", {
                        staticStyle: { "background-color": "#10182c" },
                        attrs: {
                          slot: "reference",
                          type: "text",
                          icon: "el-icon-setting",
                          size: "mini",
                          circle: "",
                        },
                        slot: "reference",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "header-cls2" }, [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      margin: "50px 0 0 0 !important",
                      "font-size": "45px",
                      color: "#fff",
                    },
                  },
                  [_vm._v(_vm._s(_vm.competitionTitle) + "\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-cls1" }, [
                _c("span", {
                  staticStyle: {
                    "padding-top": "50px",
                    "font-size": "28px",
                    "margin-right": "10%",
                    "font-weight": "500",
                    "line-height": "28px",
                    display: "flex",
                    "text-align": "center",
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                flex: "9",
                "margin-top": "70px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "zj-flex-column zj-flex-1" },
                [
                  _c(
                    "dv-border-Box-10",
                    {
                      staticStyle: { flex: "1", "margin-top": "10px" },
                      attrs: {
                        color: ["rgba(31,167,201,0)", "rgba(31,167,201,0)"],
                      },
                    },
                    [
                      _c("div", { staticClass: "box-content" }, [
                        _c(
                          "div",
                          {
                            staticClass: "zj-flex-center zj-flex-column",
                            staticStyle: {
                              width: "95%",
                              height: "90%",
                              margin: "0 auto",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "zj-flex-row zj-flex-center" },
                              [
                                _vm.ctType != null
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "hand",
                                        staticStyle: { "margin-right": "50px" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dict.ct_type[_vm.ctType].display
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.teamType_id != null
                                  ? _c("div", { staticClass: "hand" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dict.ct_subtype[_vm.ctSubtype]
                                            .display
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                (_vm.kanbanMode == 1) & (_vm.ctGrade != null)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "hand",
                                        staticStyle: { "margin-left": "50px" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dict.ct_grade[_vm.ctGrade]
                                              .display
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("dv-scroll-board", {
                              staticStyle: {
                                width: "90%",
                                height: "100%",
                                "margin-bottom": "200px",
                                "margin-top": "50px",
                              },
                              attrs: { config: _vm.config },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }